function CatalogBannerImage({ mobilePictureSource, desktopPictureSource, title }) {
  if (!mobilePictureSource && !desktopPictureSource) return null;

  return (
    <div>
      {mobilePictureSource && (
        <div className=" d-flex d-sm-none catalog-mobile-banner-container">
          <img
            src={mobilePictureSource}
            alt={title}
          />
        </div>
      )}
      {desktopPictureSource && (
        <div className="d-none d-sm-flex catalog-desktop-banner-container">
          <img
            src={desktopPictureSource}
            alt={title}
          />
        </div>
      )}
    </div>
  );
}

export default CatalogBannerImage;
